<form [formGroup]="form" NFFormValidation (validSubmit)="onSubmit()">
  <nf-form-control label="Root IDs" compact aria-required="true">
    <nf-radio-group [formControl]="rootIdType">
      <nf-radio-button
        label="Account Ids"
        value="account"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Client Ids"
        value="client"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Ultimate Parent Ids"
        value="ultimateParent"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Datafeed Ids"
        value="datafeed"
        [inline]="true"
      ></nf-radio-button>
    </nf-radio-group>
    <input type="text" class="form-control" required [formControl]="rootIds" />
  </nf-form-control>
  <hr />

  <div class="d-flex flex-row justify-content-end mt-3">
    <button
      nf-button="submit"
      [loading]="isFormSubmitting"
      [disabled]="!form.valid"
      (click)="onSubmit()"
    >
      Apply
    </button>
  </div>
</form>
